// extracted by mini-css-extract-plugin
export default {"FileThumbnail":"FileThumbnail_FileThumbnail__RO7A6","FileThumbnail__OnClick":"FileThumbnail_FileThumbnail__OnClick__I9KIG"};